import { CUSTOM_TEMPLATES } from "../services";
import fetchApi from "../utilityFunctions/customCreateApi2";

export const createTemplate = async ({ body = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.CREATE_TEMPLATE || "";
  return await fetchApi({ endpoint, body });
};

export const deployTemplate = async ({ body = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.DEPLOY_TEMPLATE || "";
  return await fetchApi({ endpoint, body });
};

export const getTemplateDetails = async ({ params = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.GET_TEMPLATE_DETAILS || "";
  return await fetchApi({ endpoint, params });
};

export const updateTemplateDetails = async ({ body = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.UPDATE_TEMPLATE_DETAILS || "";
  return await fetchApi({ endpoint, body });
};

export const addNewSection = async ({ body = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.ADD_SECTION || "";
  return await fetchApi({ endpoint, body });
};

export const updateSection = async ({ body = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.UPDATE_SECTION || "";
  return await fetchApi({ endpoint, body });
};

export const addInput = async ({ body = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.ADD_INPUT || "";
  return await fetchApi({ endpoint, body });
};

export const updateInput = async ({ body = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.UPDATE_INPUT || "";
  return await fetchApi({ endpoint, body });
};

export const deleteInput = ({ params = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.DELETE_INPUT || "";
  return fetchApi({ endpoint, params });
};

export const deleteCustomTemplate = ({ params = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.DELETE_CUSTOM_TEMPLATE || "";
  return fetchApi({ endpoint, params });
};

export const deleteSection = ({ params = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.DELETE_SECTION || "";
  return fetchApi({ endpoint, params });
};

export const deleteTemplate = ({ params = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.DELETE_TEMPLATE || "";
  return fetchApi({ endpoint, params });
};

// export const getCreateUpdateOptions = async ({ query = {}, body = {} }) => {
//   const endpoint = CUSTOM_TEMPLATES?.GET_CREATE_UPDATE_OPTIONS || "";
//   return await fetchApi({ endpoint, query, body });
// };

export const createOption = async ({ query = {}, body = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.CREATE_OPTION || "";
  return await fetchApi({ endpoint, query, body });
};

export const updateOption = async ({ query = {}, body = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.UPDATE_OPTION || "";
  return await fetchApi({ endpoint, query, body });
};

export const getOptions = async ({ query = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.GET_OPTIONS || "";
  return await fetchApi({ endpoint, query });
};

export const deleteOption = async ({ params = {} }) => {
  const endpoint = CUSTOM_TEMPLATES?.DELETE_OPTION || "";
  return await fetchApi({ endpoint, params });
};
